import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { black1, green } from 'app/components/ThemeProvider/colors';

const GlobusIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 20" sx={{ height: '20px', width: '20px', fill: 'transparent', ...sx }} {...props}>
      <g clipPath="url(#clip0_882_4745)">
        <path
          d="M1.6665 9.99984H18.3332M1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332M1.6665 9.99984C1.6665 5.39746 5.39746 1.6665 9.99984 1.6665M18.3332 9.99984C18.3332 14.6022 14.6022 18.3332 9.99984 18.3332M18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665M9.99984 1.6665C12.0842 3.94846 13.2688 6.90987 13.3332 9.99984C13.2688 13.0898 12.0842 16.0512 9.99984 18.3332M9.99984 1.6665C7.91544 3.94846 6.73088 6.90987 6.6665 9.99984C6.73088 13.0898 7.91544 16.0512 9.99984 18.3332"
          stroke={props.color === 'warning' ? green : black1}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_882_4745">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default GlobusIcon;
